
<div>
 
    <p class="page-title">Plants</p>
    <div class="section-wrapper tabletab">
      <np-tabbed>
        <ul class="tabs">
          <li role="tab" (click)="changeNav()" aria-selected="true">Manage Plants</li>
          <li role="tab" aria-selected="false">Add Plant</li>
        </ul>
  
        

        <div class="tab-content" role="tabpanel" aria-hidden="false">
          <div class="mt-10 mb-10">
            <div class="exportBtnContainer">
              <button (click)="exportToExcel()" class="primary-btn">Export To Excel</button>
            </div>
            <div >
            <p-table
              [value]="plantData"
              [scrollable]="true"
              scrollHeight="400px"
              [virtualRowHeight]="20"
              styleClass="division-table p-datatable-gridlines"
            id="StyleTable"
            >
              
            <ng-template pTemplate="header">
              <tr>
                <th >Plant</th>
                <th >Maximo Code</th>
                <th >Status</th>
                <th >Action To Take</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.PlantName }}</td>
                <td>{{ row.PlantMaximo }}</td>
                <td >{{ row.status }}</td>
                <td class="text-center">
                  <button [ngClass]="row.buttonName =='Retire'?'btn-success': 'btn-warning'" (click)="retire(row)" >{{ row.buttonName }}</button>
                </td>
              </tr>
            </ng-template>
            </p-table>
          </div>
          </div>
        </div>
  
  
        <div class="tab-content" role="tabpanel" aria-hidden="true">
          <p class="boldOne">
            Prior to adding a new plant to the Operations user interface, confirm that the external application is configured with the new plant information.</p>
            <p class="errorText" *ngIf="SaveSuccess">The item has been successfully added.</p>
            <p class="errorText" *ngIf="errorData">Please enter required fields.</p>

            <div class="manage-details-container">
            <div class="section-title boldOne">Enter Plant Data</div>
            <div class="partioned-table">
              <div class="row">
                <div class="cell label">Plant</div>
                <div class="cell value d-flex">
                  <input [(ngModel)]="newPlantName" maxlength="50"/>
                  <p class="errorText">  * Required</p>
  
                </div>
              </div>
              <div class="row">
                  <div class="cell label">Maximo Code</div>
                  <div class="cell value d-flex">
                    <input [(ngModel)]="newMaximoCode" maxlength="6"/>
                    <p class="errorText">  * Required</p>
                  </div>
                </div>
              <div class="row">
                  <div class="cell label"></div>
                  <div class="cell value">
                    <p-button label="Add New Plant" styleClass="primary-btn"  (click)="addPlant()"></p-button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </np-tabbed>
    </div>
  </div>
  